<template>
  <div id="avator">
    <div id="Avator" @mouseover="showDetailM" @mouseout="hideDetailM">
      <a href="/">
        <slot name="img"></slot>
      </a>
    </div>
    <show-detail text="back to blog" :display="display"></show-detail>
  </div>
</template>

<script>
import ShowDetail from "components/content/showDetail/ShowDetail.vue";

export default {
  name: "Avator",
  components: {
    ShowDetail,
  },
  data() {
    return {
      display: "none",
    };
  },
  props: {
    imgLink: String,
  },
  methods: {
    showDetailM() {
      this.display = "block";
    },
    hideDetailM() {
      this.display = "none";
    },
  },
};
</script>

<style scoped lang="less">
#Avator {
  height: 1.875rem;
  width: 100%;
  // background-color: pink;
  position: relative;
  overflow: hidden;
  transition: 1.5s;
  &:hover {
    transform: rotate(360deg);
    img {
      box-shadow: none;
    }
  }
  img {
    width: 1.125rem;
    height: 1.125rem;
    border: 0.0625rem @active-bgc solid;
    border-radius: 1rem;
    box-shadow: @box-shadow;
    display: block;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }
}
</style>